<template>
  <DialogTemplate :contentStyle="'max-width:520px; padding:1rem'">
    <div class="text-large weight_500 mb-6 pl-2">
      {{ $t('payment.how_did_you_find_us') }}
    </div>
    <div class="d-flex flex-wrap pb-4">
      <div
        v-for="item in adsOptions"
        :key="item"
        class="invite-box"
        @click="sendResponse(item)"
      >
        {{ item }}
      </div>
    </div>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import { gtm_sub_findUsDialog } from '@/helpers/gtm'
import { seg_track } from '@/helpers/segment'

export default {
  name: 'HowDidYouDialog',

  components: {
    DialogTemplate,
  },
  props: {
    dialog: Object,
  },
  data() {
    return {
      adsOptions: ['Google', 'Facebook', 'Streamer', 'Friend', '2+2', 'Reddit', 'Other'],
    }
  },
  methods: {
    sendResponse(item) {
      gtm_sub_findUsDialog({ source: item })
      seg_track('how_did_you_find_us', { source: item })

      this.selectedAd = item
      this.$store.dispatch('api_call', {
        method: 'post',
        endpoint: '/account/reason-found/',
        hasCancel: false,
        data: { reason_id: this.selectedAd, reason: this.selectedAd },
      })
      this.$store.dispatch('router_reset_dialogs')
    },
  },
}
</script>

<style lang="scss" scoped>
.invite-box {
  border-radius: 6px;
  padding: 0.25rem 1rem;
  margin: 0.5rem;
  font-weight: 500;
  font-size: 1.25rem;
  background: var(--clr-black-3);
  border: solid var(--clr-black-3) 1px;
  transition: 0.2s;
  cursor: pointer;
  &:hover {
    border: solid var(--clr-primary) 1px;
    background: var(--clr-primary);
  }
}
</style>
